import * as React from "react";
import * as ReactDOM from "react-dom";
import { normalize, setupPage } from "csstips";
import { App } from "./components/App";
import { cssRule, fontFace, forceRenderStyles } from "typestyle";
require("es6-promise").polyfill();

normalize();
setupPage("#root");
ReactDOM.render(<App />, document.getElementById("root"));

forceRenderStyles();

fontFace({
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: 400
});

cssRule("html, body", {
  fontFamily: "Roboto",
  height: "100%",
  width: "100%"
});

cssRule("input, button", {
  outline: "none"
});

cssRule("button[disabled]", {
  color: ""
});

cssRule("button", {
  padding: 0
});
